import { OPEN_CTA_PROMPT } from 'aria-viewer/ctaPrompt/ctaPromptActions'
import { trackEvent } from 'aria-viewer/core/middleware/analyticsMiddleware'
import * as EVENTS from 'aria-viewer/analytics/constants/desktopAnalytics'
import { getTourData } from 'aria-viewer/analytics/utils/analyticUtils'

const ctaPromptAnalytics = {
    // Desktop experience loaded through batch
    [OPEN_CTA_PROMPT]: (getState, action) => {
        const { loc_name, inst_name, stoptitle, userkey } = getTourData()(getState)

        return trackEvent(EVENTS.EXP_ACTNOW_VIEWED, {
            Institution: inst_name,
            Location: loc_name,
            Stop: stoptitle,
            Userkey: userkey,
        })
    },
}

export default ctaPromptAnalytics
